import { baseLocale } from './base';
import { sizzlenzOverrides } from './platforms/sizzlenz';
import { sizzlecpgOverrides } from './platforms/sizzlecpg';
import { miOverrides } from './languages/mi';
import type {
  TranslationKey,
  Platform,
  Language,
  PlatformOverride,
  LanguageOverride,
} from './types';
import { SUPPORTED_PLATFORMS, DEFAULT_LANGUAGE } from './types';

const platformOverrides: Record<Platform, PlatformOverride> = {
  sizzlenz: sizzlenzOverrides,
  sizzlecpg: sizzlecpgOverrides,
};

const languageOverrides: Record<string, LanguageOverride> = {
  mi: miOverrides,
};

export function detectPlatform(): Platform | null {
  const env = process.env.SIZZLE_PLATFORM;
  if (!env) return null;
  return SUPPORTED_PLATFORMS.includes(env as Platform) ? (env as Platform) : null;
}

const currentPlatform = detectPlatform();

export function resolve(key: TranslationKey, lang?: Language): string {
  const language = lang ?? DEFAULT_LANGUAGE;

  // 1. Check language + platform override
  if (language !== DEFAULT_LANGUAGE && languageOverrides[language]) {
    const langOverride = languageOverrides[language];
    if (currentPlatform && langOverride.platforms?.[currentPlatform]?.[key]) {
      return langOverride.platforms[currentPlatform]![key]!;
    }
    // 2. Check language base override
    if (langOverride.base?.[key]) {
      return langOverride.base[key]!;
    }
  }

  // 3. Check platform override
  if (currentPlatform && platformOverrides[currentPlatform]?.[key]) {
    return platformOverrides[currentPlatform]![key]!;
  }

  // 4. Return base value
  return baseLocale[key];
}
